// utils/icons.ts
import * as FaIcons from "react-icons/fa";
import * as FiIcons from "react-icons/fi";
import * as IoIcons from "react-icons/io5";
import * as MdIcons from "react-icons/md";
import * as TiIcons from "react-icons/ti";
import * as GiIcons from "react-icons/gi";
import * as WiIcons from "react-icons/wi";
import * as DiIcons from "react-icons/di";
import * as AiIcons from "react-icons/ai";
import * as BsIcons from "react-icons/bs";
import * as RiIcons from "react-icons/ri";
import * as FcIcons from "react-icons/fc";
import * as GrIcons from "react-icons/gr";
import * as HiIcons from "react-icons/hi";
import * as SiIcons from "react-icons/si";
import * as TbIcons from "react-icons/tb";
import * as CgIcons from "react-icons/cg";

// Define all available icon libraries
export const iconLibraries = {
  fa: FaIcons,
  fi: FiIcons,
  io5: IoIcons,
  md: MdIcons,
  ti: TiIcons,
  gi: GiIcons,
  wi: WiIcons,
  di: DiIcons,
  ai: AiIcons,
  bs: BsIcons,
  ri: RiIcons,
  fc: FcIcons,
  gr: GrIcons,
  hi: HiIcons,
  si: SiIcons,
  tb: TbIcons,
  cg: CgIcons,
} as const;

// Type for library prefixes
export type IconLibrary = keyof typeof iconLibraries;

// Type for complete icon name (e.g., "FaBeer", "MdHome")
export type IconName = {
  [K in IconLibrary]: keyof (typeof iconLibraries)[K];
}[IconLibrary];

// Props for Icon component
export interface IconProps {
  name: string;
  size?: number;
  color?: string;
  className?: string;
}
